module.exports = __webpack_public_path__ + "img/parra.f9e31b34.png";